export const educationData = [
    {
        id: 1,
        institution: 'Clifton High School',
        course: 'High School Education',
        startYear: '2018',
        endYear: '2021'
    },
    {
        id: 2,
        institution: 'New Jersey Institute of Technology',
        course: 'Bachelors of Information Technology (Magna Cum Laude)',
        startYear: '2021',
        endYear: '2025'
    },
   
]